export default {
  terms: 'Terms of use'
}